import { Modal, List, Button, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { isMobile } from "@/extensions/design";
const { Text } = Typography;

const ResultModal = ({ results = [], onClose }) => {
  return !isMobile ? (
    <Modal title="Результаты операции" open onCancel={() => onClose()} width={400}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Закрыть
        </Button>,
      ]}>

      {results.length === 0 ? (<p>Нет ошибок</p>) : (
        <List dataSource={results}
          renderItem={(item) => (
            <List.Item>
              <span>
                {item.saleId} - {item.errorMessage}
              </span>
            </List.Item>
          )}
        />
      )}
    </Modal>
  ) : (
    <>
      <div className="sport-modal">
        <div className="sport-modal-overlay" style={{zIndex: 0}} onClick={onClose} />
        <div className="sport-modal-content">
          <div className="sport-modal-title">
            <span>Результаты операции</span>
            <CloseOutlined onClick={onClose} className="sport-section-title-close client-close-outlined-button-style"/>
          </div>

          <div className="sport-modal-body">
            {results.length === 0 ? (
              <p>Нет ошибок</p>
            ) : (
              <div>
                {results.map((item, index) => (
                  <Text style={{fontSize: "16px", marginLeft: "4px"}} key={index}>
                   {item.saleId} — {item.errorMessage}
                  </Text>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultModal;
